import { Auth, useAuth } from '../../services/AuthService';
import { filter, switchMap, take } from 'rxjs/operators';
import { useContext, useEffect } from 'react';
import { Subscription } from 'rxjs';
import { AuthActions } from 'ionic-appauth';
import { useLogger } from '../../services/LogService';
import { AppContext } from '../../state/AppContextProvider';
import { ActionType } from '../../state/GlobalState';

interface AuthenticationProps { children }

const Authentication: React.FC<AuthenticationProps> = ({ children }) => {
  const { state, dispatch } = useContext(AppContext);

  const logger = useLogger('Authentication');

  const auth = useAuth();

  const subscribeSSO = (): Subscription => {
    const sub: Subscription = auth.initComplete$
      .pipe(
        filter((complete) => complete),
        switchMap(() => auth.isAuthenticated$),
        take(1)
      )
      .subscribe((isAuthenticated) => {
        logger.info('SSO subscription -> isAuthenticated=' + isAuthenticated);
        if (isAuthenticated) {
          dispatch({
            type: ActionType.Connect,
            payload: true,
          });
        } else {
          // dispatch({
          //   type: ActionType.Disconnect,
          //   payload: false,
          // });
        }
      });
    return sub;
  };

  const subscribeActions = (): Subscription => {
    const sub: Subscription = auth.events$.subscribe((action) => {
      logger.info('subscribeActions() action = ' + action.action);
      if (action.action === AuthActions.SignInSuccess) {
        dispatch({
          type: ActionType.Connect,
          payload: true,
        });
      } else if (
        action.action === AuthActions.SignInFailed &&
        !state.isConnected
      ) {
        logger.info('subscribeActions() disconnect');
        dispatch({
          type: ActionType.Disconnect,
          payload: false,
        });
      } else if (
        action.action === AuthActions.SignOutSuccess &&
        state.isConnected
      ) {
        dispatch({
          type: ActionType.Disconnect,
          payload: false,
        });
      } else if (action.action === AuthActions.SignOutFailed) {
        dispatch({
          type: ActionType.Disconnect,
          payload: false,
        });
      } else if (action.action === AuthActions.LoadTokenFromStorageFailed) {
        dispatch({
          type: ActionType.Disconnect,
          payload: false,
        });
      }
    });
    return sub;
  };

  useEffect(() => {
    logger.info('useEffect() state.isAuthLoaded = ' + state.isAuthLoaded);
    let sub: Subscription[] = [];
    Auth.getWpToken().then((wpToken) => {
      if (wpToken) {
        logger.info('useEffect() wp token found');
        // dont login with sso
        dispatch({
          type: ActionType.Connect,
          payload: true,
        });
        sub.push(subscribeActions());
      } else {
        logger.info('useEffect() NO wp token found');
        sub.push(subscribeSSO());
        sub.push(subscribeActions());
      }
    }).catch((e)=> logger.error('useEffect() Auth.getWpToken()',e));
    return () => {
      sub.every((it) => it.unsubscribe());
    };
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  useEffect(()=> {
    console.log('state.isAuthLoaded',state.isAuthLoaded);
  }, [state.isAuthLoaded])

  return state.isAuthLoaded ? children : <></>;
};

export default Authentication;
